// Notification Action Types
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS'
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'
